module.exports = __webpack_public_path__ + "img/nftx.1ba6d71f.svg";